<input type="file" #file style="display: none" [accept]="accept" (change)="_onFilesAdded()"/>
